module.exports = __webpack_public_path__ + "media/application/images/masthead-992ae27a80fe5eda18984e712ef945e6.jpg";